export const STYLE = {
    DEFAULT_BUTTON: "bg-blue-700 px-6 py-2 text-white font-bold rounded-md hover:bg-blue-200 hover:text-blue-800 transition-colors"
}